// extracted by mini-css-extract-plugin
module.exports = {"timePicker":"style-module_timePicker__2O1MP-I0CsSsvty4ehFMMU","digit":"style-module_digit__zFKN21heWFKf98qD8Y1Vb"};